<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Şube</label>
            <v-validator :errors="errors" parameter="BranchId" :watch="branch">
                <v-select-list v-model="branch" placeholder="Şube" label="Name" :options="branches"/>   
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Garaj</label>
            <v-validator :errors="errors" parameter="GarageName" :watch="value.GarageName">
                <input type="text" class="form-control" placeholder="Garaj" v-model="value.GarageName"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Puantaj Sorumlusu</label>
            <v-validator :errors="errors" parameter="EmployeeId" :watch="employee">
                <v-select-list v-model="employee" :options="employees" label="FullName" v-on:search="searchEmployees" placeholder="Puantaj Sorumlusu" :loading="employeeLoading"></v-select-list>
            </v-validator>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import EmployeeOperationsApi from '@/api/employee-operations'
import VValidator from '@/components/VValidator.vue'
export default {
  components: { VValidator },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            branches:[],
            employeeLoading:false,
            employees:[]
        }
    },  
    mounted(){
        this.getBranches()
        if(this.value.EmployeeFullName){
            this.searchEmployees(this.value.EmployeeFullName)
        }
    },
    watch:{
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.ListByCode("o")
            .then(res=>{
                this.branches = res.data.Data
            })
        },
        searchEmployees(search){
            if(search){
                this.employeeLoading = true
                EmployeeOperationsApi.Employee.Search(search)
                .then(res=>{
                    this.employees = res.data.Data
                    this.employeeLoading = false
                }).catch(err=>{ 
                    this.employeeLoading = false 
                })
            }
        },

    },
    computed:{
        employee:{
            get:function(){
                return this.employees.find(s=>s.Id==this.value.EmployeeId)
            },
            set:function(value){
                this.value.EmployeeId = value?.Id || null
            }
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.BranchId)
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        }
    }
}
</script>

<style lang="scss">
</style>